export default {"src":"/_next/static/media/icon-open-ai.5239e9ba.svg","height":24,"width":99,"blurWidth":0,"blurHeight":0};